import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function RefocusWidgetDemo({ onClose }) {
  const { user } = useAuth();
  const [elapsed, setElapsed] = useState(0);
  const position = user?.settings?.widget_position || "bottom-right";
  const last = user?.hierarchy?.[0] || { name: "Priority work", category: "App", kind: "app" };

  useEffect(() => {
    const t = setInterval(() => setElapsed((e) => e + 1), 1000);
    return () => clearInterval(t);
  }, []);

  const cls = `fixed z-[80] m-6 ${position.includes("top") ? "top-16" : "bottom-0"} ${position.includes("left") ? "left-0" : "right-0"}`;

  return (
    <>
      <div className="fixed inset-0 bg-[#1A1A2E]/30 backdrop-blur-sm z-[70]" onClick={onClose} />
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.25 }}
        className={`${cls} bg-white/85 backdrop-blur-xl border border-white/60 rounded-xl p-5 w-72 shadow-[0_20px_60px_rgba(26,58,92,0.18)] soft-pulse`}
        data-testid="refocus-widget"
      >
        <div className="flex items-center justify-between mb-3">
          <span className="text-[10px] uppercase tracking-[0.2em] text-[#2C6BAC] font-semibold">Refocus</span>
          <span className="font-mono text-[10px] text-[#555568]">live demo</span>
        </div>
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 rounded-md bg-[#1A3A5C] text-white flex items-center justify-center font-bold">
            {last.name.slice(0, 2)}
          </div>
          <div>
            <p className="text-sm font-bold text-[#1A1A2E]">{last.name}</p>
            <p className="text-xs text-[#555568]">{last.category} · {last.kind}</p>
          </div>
        </div>
        <div className="mt-4 pt-3 border-t border-[#E8ECF2] flex items-center justify-between">
          <p className="font-mono text-xs text-[#555568]">⏱ {String(Math.floor(elapsed / 60)).padStart(2, "0")}:{String(elapsed % 60).padStart(2, "0")} ago</p>
          <Button size="sm" onClick={onClose} className="h-7 bg-[#2C6BAC] hover:bg-[#1A3A5C] text-white" data-testid="refocus-dismiss">
            Dismiss
          </Button>
        </div>
      </motion.div>
    </>
  );
}
